import React, { useEffect, useState } from "react";
import { DeployedYear, DropdownMonthList, EmptyString, InsertDateFormat } from "utils/Constant";
import { money } from "utils/helpers";
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import CheckCircleIcon from "assets/icon/CheckCircleIcon";
import HideIcon from "assets/icon/HideIcon";
import ShowIcon from "assets/icon/ShowIcon";
import SaveIcon from "assets/icon/SaveIcon";
import Dropdown from "components/Input/Dropdown";
import SearchButton from "components/Button/SearchButton";
import { useModal } from "utils/context/ModalContext";
import { TransactionService } from "services/TransactionService/TransactionService";
import { PaymentReceivedService } from "services/PaymentReceivedService/PaymentReceivedService";
import { MainBodyCard, PagesTitle } from "components/Cards";

export default function PaymentReceived(){
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchTransactionReportEdc} = TransactionService()
    const { fetchPaymentReceivedTransactionList, fetchUpdatePaymentReceived } = PaymentReceivedService()
        
    const [date, setDate] = useState(new Date())
    const [transactionList, setTransactionList] = useState([])
    const [showSalesDetail, setShowSalesDetail] = useState(false)
    const [showNettQrisDetail, setShowNettQrisDetail] = useState(false)
    const [groupByOptions, setGroupByOptions] = useState([
        { label: "EDC", value: "edc" },
        { label: "Day", value: "day" },
    ])
    const [groupBy, setGroupBy] = useState("day")
    const [edcOptions, setEdcOptions] = useState([])
    const [edcId, setEdcId] = useState("")
    const [monthOptions, setMonthOptions] = useState(DropdownMonthList)
    const [month, setMonth] = useState(moment(new Date()).format("M"))
    const [year, setYear] = useState(moment(new Date()).format("YYYY"))
    const [yearOptions, setYearOptions] = useState([])

    const getYearOptions = () => {
        let startYear = parseInt(DeployedYear)
        let thisYear = parseInt(moment(new Date()).format("yyyy"))

        let tempArray = []
        for (let i = startYear; i <= thisYear; i++){
            tempArray.push( {label: String(i), value: String(i)} )
        }

        setYearOptions(tempArray)
    }
    // Event Handlers
    
    const dateChange = (e) => {
        if (e === null) {
            setDate(new Date())
        }else{
            setDate(e)
        }
    }
    const paymentReceivedChange = (index, key, value) => {
        const newData = [...transactionList];
        newData[index][key] = money(value);
        setTransactionList(newData);
    }
    const groupByChange = (e) => {
        setGroupBy(e.value)
    }

    const saveBtnClick = async (edcId, date, paymentReceived) => {
        showLoading()

        try {
            const res = await fetchUpdatePaymentReceived(edcId, moment(date).format(InsertDateFormat), paymentReceived.replaceAll(",", ""))
            if (!res) return
        }
        finally {
            hideLoading()
        }
    }
    const matchBtnClick = async (trxDate, nettoOnUs, nettoOffUs, nettoQrisOnUs, nettoQrisOffUs, nettoCreditAmex, nettoDebitOnUs, nettoDebitOffUs, edcId, index, key) => {        
        let paymentReceived = String(Math.floor(parseFloat(nettoOffUs)) + Math.floor(parseFloat(nettoOnUs)) + Math.floor(parseFloat(nettoQrisOnUs)) + Math.floor(parseFloat(nettoQrisOffUs)) + Math.floor(parseFloat(nettoCreditAmex)) + Math.floor(parseFloat(nettoDebitOnUs)) + Math.floor(parseFloat(nettoDebitOffUs)))

        showLoading()

        try {
            const res = await fetchUpdatePaymentReceived(edcId, moment(trxDate).format(InsertDateFormat), paymentReceived)
            if (!res) return

            if (groupBy === "day"){
                setTransactionList(prev =>
                    prev.map(item =>
                    item.edcId === edcId
                        ? { ...item, paymentReceived: paymentReceived }
                        : item
                    )
                )
            } else {
                setTransactionList(prev =>
                    prev.map(item =>
                    moment(item.transactionDate).format('DD MMM yyyy') === moment(trxDate).format('DD MMM yyyy')
                        ? { ...item, paymentReceived: paymentReceived }
                        : item
                    )
                )
            }            
        }
        finally {
            hideLoading()
        }
    }
    const searchClick = () => {
        if (edcId !== EmptyString){
            showLoading()

            try {
                getTransaction()
            }
            finally {
                hideLoading()
            }
        }
    }
    const showSalesDetailClick = () => {
        setShowSalesDetail(!showSalesDetail)
    }
    const showNettQrisDetailClick = () => {
        setShowNettQrisDetail(!showNettQrisDetail)
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()
        
            try {
                if (groupBy === "edc"){
                    getYearOptions()

                    // Get EDC List
                    const resGetEDC = await fetchTransactionReportEdc(
                        moment(new Date(year, month - 1, 1)).format(InsertDateFormat),
                        moment(new Date(year, month, 0)).format(InsertDateFormat),
                        "1"
                    )
                    if (!resGetEDC) return

                    let data = resGetEDC.data

                    const options = data.map((item) => ({
                        label: `${item.bankCode} - ${item.edcName}`,
                        value: String(item.edcId)
                    }));

                    setEdcOptions(options)
                    setEdcId(edcId)

                    // Initialize transaction list
                    setTransactionList([])

                    if (edcId !== ""){
                        getTransaction()
                    }
                } else {
                    getTransaction()
                }
            }
            finally {
                hideLoading()
            }            
        }    
        
        onLoad()
    },[date, groupBy])

    // Function Api Call
    const getTransaction = async () => {
        const res = await fetchPaymentReceivedTransactionList(date, groupBy, edcId, year, month)
        if (!res) return

        setTransactionList(res.data)
    }

    function fCheckPaymentReceived(nettoOnUs, nettoOffUs, nettoQrisOnUs, nettoQrisOffUs, nettoCreditAmex, nettoDebitOnUs, nettoDebitOffUs, paymentReceived){
        let onUs = Math.floor(parseFloat(nettoOnUs))
        let offUs = Math.floor(parseFloat(nettoOffUs))
        let qrisOnUs = Math.floor(parseFloat(nettoQrisOnUs))
        let qrisOffUs = Math.floor(parseFloat(nettoQrisOffUs))
        let creditAmex = Math.floor(parseFloat(nettoCreditAmex))
        let debitOnUs = Math.floor(parseFloat(nettoDebitOnUs))
        let debitOffUs = Math.floor(parseFloat(nettoDebitOffUs))
        let payment = Math.floor(parseFloat(paymentReceived))

        let totalNetto = onUs + offUs + qrisOnUs + qrisOffUs + creditAmex + debitOnUs + debitOffUs

        if (totalNetto == payment){
            return true
        }else{
            return false
        }
    }

    const previousDayClick = async () => {
        setDate(moment(date).subtract(1, 'day'))
    }
    const nextDayClick = async () => {
        setDate(moment(date).add(1, 'day'))
    }

    return(
        <MainBodyCard>
            <PagesTitle title='Payment Received' />

            <div className="hidden sm:flex gap-4 items-center mt-3">
                <span className="font-semibold">Group By</span>
                <Dropdown className="w-24" options={groupByOptions} value={groupBy} onChange={groupByChange} />
            </div>

            {groupBy === "edc" && (
                <div className="mt-3">
                    <div className="flex gap-2">
                        <div className="flex flex-col gap-2">
                            <span>Month</span>
                            <Dropdown className="w-72" options={monthOptions} value={month} onChange={(e) => setMonth(e.value)} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <span>Year</span>
                            <Dropdown className="w-36" options={yearOptions} value={year} onChange={(e) => setYear(e.value)} />
                        </div>
                        <div className="flex flex-col gap-2">
                            <span>EDC</span>
                            <Dropdown className="w-72" options={edcOptions} value={edcId} onChange={(e) => setEdcId(e.value)} placeholder="Select EDC" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <span>&nbsp;</span>
                            <SearchButton onClick={searchClick} />
                        </div>
                    </div>

                    <div className="hidden xl:block mt-3">
                        <table className="w-full border bg-white text-md font-light mt-4">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold w-16">No</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell w-32">Tanggal</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Total Sales</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Off Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Qris On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Qris Off Us</th>
                                    <th className="font-semibold text-left px-2">N. On Us</th>
                                    <th className="font-semibold text-left px-2">N. Off Us</th>
                                    <th className={`font-semibold text-left px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>N. Qris On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>N. Qris Off Us</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Total Netto</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Payment Received</th>
                                    <th className="font-semibold text-center px-2 w-28">Action</th>
                                </tr>
                            </thead>
                            {transactionList?.length > 0 ? 
                                <tbody className="border">
                                    {transactionList?.map((data, i) => {
                                        return(
                                            <tr className={`my-2 row h-10 border-y hover:opacity-80 
                                                ${ fCheckPaymentReceived(data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.nettoCreditAmex, data.nettoDebitOnUs, data.nettoDebitOffUs, data.paymentReceived) ? 'bg-yellow-400' : 'bg-gray-100' }`} key={ i }>
                                                <td className="text-center">{ data.rowNumber }</td>
                                                <td className="px-2">
                                                    <span>{ moment(data.transactionDate).format('DD MMM yyyy') }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolume)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOffUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOnUs)))) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOffUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoQrisOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2 font-semibold">
                                                    <span>
                                                        Rp { 
                                                            money(String(
                                                                Math.floor(parseFloat(data.nettoOffUs)) + 
                                                                Math.floor(parseFloat(data.nettoOnUs)) + 
                                                                Math.floor(parseFloat(data.nettoQrisOnUs)) + 
                                                                Math.floor(parseFloat(data.nettoQrisOffUs)) + 
                                                                Math.floor(parseFloat(data.nettoCreditAmex)) + 
                                                                Math.floor(parseFloat(data.nettoDebitOnUs)) + 
                                                                Math.floor(parseFloat(data.nettoDebitOffUs))                                                                    
                                                            ))  }
                                                    </span>
                                                </td>
                                                <td className="px-2 py-1">
                                                    <input className="border px-4 py-2 rounded w-[180px]" value={money(data.paymentReceived)} onChange={(e) => {paymentReceivedChange(i, 'paymentReceived', e.target.value)}}></input>
                                                </td>
                                                <td className="">
                                                    <div className="flex gap-2 justify-center">
                                                        <button className="flex items-center gap-2 bg-black rounded-md px-2 py-2" 
                                                            onClick={() => {matchBtnClick(data.transactionDate, data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.nettoCreditAmex, data.nettoDebitOnUs, data.nettoDebitOffUs, data.edcId, i, 'paymentReceived')}}>
                                                            <CheckCircleIcon className="fill-white w-6" />
                                                        </button>
                                                        <button className="flex items-center bg-black rounded-md px-2 py-2" onClick={(e) => saveBtnClick(data.edcId, data.transactionDate, data.paymentReceived)} >
                                                            <SaveIcon className="fill-white w-6" />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            :
                                <tbody>
                                    <tr>
                                        <td className="text-center" colSpan={12}>
                                            <span>No Transaction Data</span>
                                        </td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
            )}

            {groupBy === "day" && (
                <div>
                    <div className="flex flex-col sm:flex-row gap-5 mt-2 sm:mt-3">
                        <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                            <div className="flex flex-col gap-2 w-42">
                                <span>Date</span>
                                <div className="flex gap-2">
                                    <DatePicker className="w-full h-10 bg-white" value={date} onChange={dateChange} />
                                    <button className="button text-nowrap" onClick={previousDayClick}>H-1</button>
                                    <button className="button text-nowrap" onClick={nextDayClick}>H+1</button>
                                </div>                                
                            </div>
                        </div>
                    </div>

                    <div className="hidden sm:flex mt-5 gap-2 justify-end">
                        <button className="px-4 py-2 bg-black rounded-md flex items-center gap-2" onClick={showSalesDetailClick}>
                            {showSalesDetail ? 
                                <HideIcon />
                                :
                                <ShowIcon className="fill-white w-6" />
                            }
                            <span className="text-white">{showSalesDetail ? 'Sales Detail' : 'Sales Detail'}</span>
                        </button>
                        <button className="px-4 py-2 bg-black rounded-md flex items-center gap-2" onClick={showNettQrisDetailClick}>
                            {showNettQrisDetail ? 
                                <HideIcon />
                                :
                                <ShowIcon className="fill-white w-6" />
                            }
                            <span className="text-white">{showSalesDetail ? 'Nett Qris Detail' : 'Nett Qris Detail'}</span>
                        </button>
                    </div>
                            
                    {/* WEB VIEW */}
                    <div className="hidden xl:block mt-3">
                        <table className="w-full border bg-white text-md font-light mt-4">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold w-16">No</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell w-[260px]">EDC Name</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Total Sales</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Off Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Qris On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>S. Qris Off Us</th>
                                    <th className="font-semibold text-left px-2">N. On Us</th>
                                    <th className="font-semibold text-left px-2">N. Off Us</th>
                                    <th className={`font-semibold text-left px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>N. Qris On Us</th>
                                    <th className={`font-semibold text-left px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>N. Qris Off Us</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Total Netto</th>
                                    <th className="font-semibold text-left px-2 hidden sm:table-cell">Payment Received</th>
                                    <th className="font-semibold text-center px-2 w-28">Action</th>
                                </tr>
                            </thead>
                            {transactionList?.length > 0 ? 
                                <tbody className="border">
                                    {transactionList?.map((data, i) => {
                                        return(
                                            <tr className={`my-2 row h-10 border-y hover:opacity-80 ${ fCheckPaymentReceived(data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.nettoCreditAmex, data.nettoDebitOnUs, data.nettoDebitOffUs, data.paymentReceived) ? 'bg-yellow-400' : 'bg-gray-100' }`} key={ i }>
                                                <td className="text-center">{ data.rowNumber }</td>
                                                <td className="px-2">
                                                    <span>{ data.bankCode + " - " + data.edcName.toUpperCase() }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolume)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeOffUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showSalesDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.salesVolumeQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOnUs)))) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoOffUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoQrisOnUs)))) }</span>
                                                </td>
                                                <td className={`px-2 ${showNettQrisDetail ? 'table-cell' : 'hidden'}`}>
                                                    <span>Rp { money(String(Math.floor(parseFloat(data.nettoQrisOffUs)))) }</span>
                                                </td>
                                                <td className="px-2 font-semibold">
                                                    <span>
                                                        Rp { 
                                                            money(String(
                                                                Math.floor(parseFloat(data.nettoOffUs)) + 
                                                                Math.floor(parseFloat(data.nettoOnUs)) + 
                                                                Math.floor(parseFloat(data.nettoQrisOnUs)) + 
                                                                Math.floor(parseFloat(data.nettoQrisOffUs)) + 
                                                                Math.floor(parseFloat(data.nettoCreditAmex)) + 
                                                                Math.floor(parseFloat(data.nettoDebitOnUs)) + 
                                                                Math.floor(parseFloat(data.nettoDebitOffUs))                                                                    
                                                            ))  }
                                                    </span>
                                                </td>
                                                <td className="px-2 py-1">
                                                    <input className="border px-4 py-2 rounded w-[180px]" value={money(data.paymentReceived)} onChange={(e) => {paymentReceivedChange(i, 'paymentReceived', e.target.value)}}></input>
                                                </td>
                                                <td className="">
                                                    <div className="flex gap-2 justify-center">
                                                        <button className="flex items-center gap-2 bg-black rounded-md px-2 py-2" 
                                                            onClick={() => {matchBtnClick(data.transactionDate, data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.nettoCreditAmex, data.nettoDebitOnUs, data.nettoDebitOffUs, data.edcId, i, 'paymentReceived')}}>
                                                            <CheckCircleIcon className="fill-white w-5" />
                                                        </button>
                                                        <button className="flex items-center bg-black rounded-md px-2 py-2" onClick={(e) => saveBtnClick(data.edcId, data.transactionDate, data.paymentReceived)} >
                                                            <SaveIcon className="fill-white w-5" />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            :
                                <tbody>
                                    <tr>
                                        <td className="text-center" colSpan={12}>
                                            <span>No Transaction Data</span>
                                        </td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                    
                    {/* MOBILE VIEW */}
                    <div className="xl:hidden mt-5">
                        {transactionList?.length > 0 ? 
                            <div className="flex flex-col gap-2">
                                {transactionList?.map((data, i) => {
                                    return(
                                        <div className={`p-2 border rounded-md flex justify-between items-center ${
                                                parseInt(data.paymentReceived) === parseInt(data.nettoOnUs) + parseInt(data.nettoOffUs) + parseInt(data.nettoQrisOnUs) + parseInt(data.nettoQrisOffUs) + parseInt(data.nettoCreditAmex) + parseInt(data.nettoDebitOnUs) + parseInt(data.nettoDebitOffUs)
                                                ? 'bg-yellow-400' : ''
                                            }`}>
                                            <div className="flex flex-col">
                                                <label>{data.bankCode + " - " + data.edcName}</label>
                                                <label className="font-semibold">Netto : Rp { money(String(Math.floor(parseFloat(data.nettoOffUs)) + Math.floor(parseFloat(data.nettoOnUs)) + Math.floor(parseFloat(data.nettoQrisOnUs)) + Math.floor(parseFloat(data.nettoQrisOffUs)))) }</label>
                                            </div>

                                            <div className="">
                                                <button className="flex items-center gap-2 bg-black rounded-md px-2 py-2" 
                                                    onClick={() => {matchBtnClick(data.transactionDate, data.nettoOnUs, data.nettoOffUs, data.nettoQrisOnUs, data.nettoQrisOffUs, data.nettoCreditAmex, data.nettoDebitOnUs, data.nettoDebitOffUs, data.edcId, i, 'paymentReceived')}}>
                                                    <CheckCircleIcon className="fill-white w-6" />
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        :
                            <div>
                                <span>No Transaction Data</span>
                            </div>
                        }
                    </div>
                </div>
            )}
        </MainBodyCard>
    )
}